import { render, staticRenderFns } from "./mycollect.vue?vue&type=template&id=b2541358&scoped=true&"
import script from "./mycollect.vue?vue&type=script&lang=js&"
export * from "./mycollect.vue?vue&type=script&lang=js&"
import style0 from "./mycollect.vue?vue&type=style&index=0&id=b2541358&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./mycollect.vue?vue&type=style&index=1&id=b2541358&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style2 from "./mycollect.vue?vue&type=style&index=2&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2541358",
  null
  
)

export default component.exports